export default __webpack_public_path__ + "c3ea1ab859ceb2778f2fab8096cf41d0.jpg";